const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefundB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.103216,0,0,0.103216,1.99997,2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.203,41.104L139.855,53.113C160.005,68.792 170.056,94.176 166.089,119.366C163.183,137.85 153.251,154.096 138.125,165.114C122.994,176.126 104.485,180.602 86.001,177.681C47.844,171.673 21.681,135.743 27.679,97.583C30.585,79.097 40.52,62.85 55.648,51.835C68.856,42.22 84.639,37.602 100.734,38.518L87.579,52.319L97.338,61.632L118.104,39.831L118.109,39.839L127.412,30.07L117.66,20.767L117.655,20.77L95.862,0L86.552,9.769L100.752,23.294C81.449,22.381 62.542,27.996 46.693,39.536C28.28,52.943 16.19,72.717 12.65,95.221C5.348,141.666 37.19,185.405 83.635,192.714C88.124,193.422 92.611,193.769 97.069,193.769C114.959,193.769 132.342,188.146 147.08,177.413C165.495,164.004 177.583,144.23 181.123,121.731C185.952,91.077 173.72,60.181 149.203,41.104Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.203061,0,0,0.203061,56.1098,72.1099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.682,229.329C127.968,229.329 138.877,228.6 149.2,227.243L149.2,114.094C138.878,112.738 127.968,112.009 116.682,112.009C52.241,112.009 0.001,135.702 0.001,164.93L0.001,176.407C0.001,205.634 52.241,229.329 116.682,229.329Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.682,288.411C127.968,288.411 138.877,287.682 149.2,286.327L149.2,253.161C138.875,254.517 127.971,255.256 116.682,255.256C60.432,255.256 13.483,237.202 2.455,213.174C0.849,216.674 0.001,220.298 0.001,224.013L0.001,235.49C0.001,264.718 52.241,288.411 116.682,288.411Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.199,314.823L149.199,312.245C138.874,313.601 127.97,314.34 116.681,314.34C60.431,314.34 13.482,296.286 2.454,272.258C0.848,275.757 0,279.381 0,283.096L0,294.573C0,323.802 52.24,347.495 116.681,347.495C129.568,347.495 141.963,346.545 153.554,344.795C150.681,338.918 149.199,332.72 149.199,326.299L149.199,314.823Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,22.379C220.479,22.379 168.239,46.072 168.239,75.3L168.239,86.777C168.239,116.005 220.479,139.698 284.92,139.698C349.36,139.698 401.601,116.005 401.601,86.777L401.601,75.3C401.601,46.072 349.36,22.379 284.92,22.379Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,165.626C228.67,165.626 181.721,147.573 170.693,123.544C169.087,127.043 168.239,130.667 168.239,134.383L168.239,145.86C168.239,175.088 220.479,198.781 284.92,198.781C349.36,198.781 401.601,175.088 401.601,145.86L401.601,134.383C401.601,130.667 400.753,127.043 399.147,123.544C388.119,147.573 341.17,165.626 284.92,165.626Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,224.71C228.67,224.71 181.721,206.656 170.693,182.628C169.087,186.127 168.239,189.751 168.239,193.467L168.239,204.944C168.239,234.173 220.479,257.866 284.92,257.866C349.36,257.866 401.601,234.173 401.601,204.944L401.601,193.467C401.601,189.751 400.753,186.127 399.147,182.628C388.119,206.657 341.17,224.71 284.92,224.71Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,286.983C228.67,286.983 181.721,268.929 170.693,244.901C169.087,248.401 168.239,252.024 168.239,255.739L168.239,267.217C168.239,296.445 220.479,320.138 284.92,320.138C349.36,320.138 401.601,296.445 401.601,267.217L401.601,255.739C401.601,252.024 400.753,248.399 399.147,244.901C388.119,268.928 341.17,286.983 284.92,286.983Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.92,346.066C228.67,346.066 181.721,328.013 170.693,303.985C169.087,307.485 168.239,311.11 168.239,314.823L168.239,326.3C168.239,355.528 220.479,379.221 284.92,379.221C349.36,379.221 401.601,355.528 401.601,326.3L401.601,314.822C401.601,311.107 400.753,307.482 399.147,303.984C388.119,328.012 341.17,346.066 284.92,346.066Z",
    style: {
      fill: "rgb(114,114,114)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundB);
export default __webpack_public_path__ + "static/media/refund_b.913a6c34cd3a895fbfb426ba3b2cf09d.svg";
export { ForwardRef as ReactComponent };